import { ReactNode } from "react";

export interface IModalBody {
  children?: ReactNode;
  className?: string;
}

function ModalBody({ children, className }: IModalBody) {
  return (
    <div className={`modal-body text-center py-0 modal-body ` + className}>
      {children}
    </div>
  );
}
export default ModalBody;
